/**
 * Copyright © Born, Inc. All rights reserved.
 * See COPYING.txt for license details.
 */
define('Born_GrabExpress/js/model/address-converter-mixin',[
    'jquery',
    'mage/utils/wrapper'
], function ($, wrapper) {
    'use strict';

    return function (addressConverter) {
        addressConverter.quoteAddressToFormAddressData =
            wrapper.wrapSuper(addressConverter.quoteAddressToFormAddressData, function (addrs) {
                var output = this._super(addrs);
                var customAttributesObject;
                if ($.isArray(addrs.customAttributes)) {
                    customAttributesObject = {};
                    addrs.customAttributes.forEach(function (value) {
                        customAttributesObject[value.attribute_code] = value.value;
                    });
                    output.custom_attributes = customAttributesObject;
                }

                return output;
        });

        return addressConverter;
    };
});
